<template>
    <div>
        <!-- Start Blog Area -->
		<section class="blog-area ptb-80 mt-5">
			<div class="container">
                <div class="section-title">
					<h2>Our Blogs</h2>
					<div class="bar"></div>
                    <p>Working with us you can lift the web reputation of your company 
                        higher than ever. We can offer you all the advantages of modern 
                        digital marketing services in Bangladesh. </p>
				</div>
                
				<div class="row">
                    <div class="col-lg-8 col-md-12">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="single-blog-post">
                                    <div class="blog-image">
                                        <a href="#">
                                            <img src="../../../assets/img/blog-image/1.jpg" alt="image">
                                        </a>

                                        <div class="date">
                                            <feather type="calendar"></feather> March 15, 2021
                                        </div>
                                    </div>

                                    <div class="blog-post-content">
                                        <h3><router-link to="/blog-details/NeedWebSide">Why does your business need a website?</router-link></h3>

                                        <span>by <a href="#">WB-Software</a></span>

                                        <p>In today's world everybody has a smartphone and a business owner like you can take advantage of this by creating an app for your business. An app is a very good way to cultivate customer loyalty as it gives you and your customer a genuine way to communicate directly.</p>

                                         <router-link to="/blog-details/NeedWebSide" class="read-more-btn">Read More <feather type="plus-circle"></feather></router-link>
                                    </div>
                                </div>
                            </div>
        
                            <div class="col-lg-6 col-md-6">
                                <div class="single-blog-post">
                                    <div class="blog-image">
                                        <a href="#">
                                            <img src="../../../assets/img/blog-image/2.jpg" alt="image">
                                        </a>

                                        <div class="date">
                                            <feather type="calendar"></feather> March 17, 2021
                                        </div>
                                    </div>

                                    <div class="blog-post-content">
                                        <h3><router-link to="/blog-details/NeedApps">Why does your business need an app?</router-link></h3>

                                        <span>by <a href="#">WB-Software</a></span>

                                        <p>Over 90% of people have access to the internet and what you need is a website to reach them all. A website will prove your brand credibility. over 30% of people don't consider a business if it does not have any website. So if you want your customer to think that your business is...</p>

                                        <router-link to="/blog-details/NeedApps" class="read-more-btn">Read More <feather type="plus-circle"></feather></router-link>
                                    </div>
                                </div>
                            </div>
        
                            <div class="col-lg-6 col-md-6">
                                <div class="single-blog-post">
                                    <div class="blog-image">
                                        <a href="#">
                                            <img src="../../../assets/img/blog-image/4.jpg" alt="image">
                                        </a>

                                        <div class="date">
                                            <feather type="calendar"></feather> March 19, 2021
                                        </div>
                                    </div>

                                    <div class="blog-post-content">
                                        <h3><router-link to="/blog-details/NeedDigitalMarketing">Why does your business need digital marketing?</router-link></h3>

                                        <span>by <a href="#">WB-Software</a></span>

                                        <p>Each business has a different set of goals to reach, but the main among them is always reach. Digital marketing can really be helpful for many small and large scale businesses, here is why you need digital marketing. It is the most affordable means of...</p>

                                        <router-link to="/blog-details/NeedDigitalMarketing" class="read-more-btn">Read More <feather type="plus-circle"></feather></router-link>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-6 col-md-6">
                                <div class="single-blog-post">
                                    <div class="blog-image">
                                        <a href="#">
                                            <img src="../../../assets/img/blog-image/5.jpg" alt="image">
                                        </a>

                                        <div class="date">
                                            <feather type="calendar"></feather> March 19, 2021
                                        </div>
                                    </div>

                                    <div class="blog-post-content">
                                        <h3><router-link to="/blog-details/WhyECommerce">How can eCommerce help your business?</router-link></h3>

                                        <span>by <a href="#">WB-Software</a></span>

                                        <p>Each business has a different set of goals to reach, but the main among them is always reach. Digital marketing can really be helpful for many small and large scale businesses, here is why you need digital marketing. It is the most affordable means of...</p>
                                        <router-link to="/blog-details/WhyECommerce" class="read-more-btn">Read More <feather type="plus-circle"></feather></router-link>
                                    </div>
                                </div>
                            </div>
        
                            <div class="col-lg-6 col-md-6">
                                <div class="single-blog-post">
                                    <div class="blog-image">
                                        <a href="#">
                                            <img src="../../../assets/img/blog-image/3.jpg" alt="image">
                                        </a>

                                        <div class="date">
                                            <feather type="calendar"></feather> March 19, 2021
                                        </div>
                                    </div>

                                    <div class="blog-post-content">
                                        <h3><router-link to="/blog-details/AppVsWeb">App vs Website: which one is better?</router-link></h3>

                                        <span>by <a href="#">WB-Software</a></span>

                                        <p>Each business has a different set of goals to reach, but the main among them is always reach. Digital marketing can really be helpful for many small and large scale businesses, here is why you need digital marketing. It is the most affordable means of...</p>
                                        <router-link to="/blog-details/AppVsWeb" class="read-more-btn">Read More <feather type="plus-circle"></feather></router-link>
                                    </div>
                                </div>
                            </div>
        
                            <div class="col-lg-6 col-md-6">
                                <div class="single-blog-post">
                                    <div class="blog-image">
                                        <a href="#">
                                            <img src="../../../assets/img/blog-image/6.jpg" alt="image">
                                        </a>

                                        <div class="date">
                                            <feather type="calendar"></feather> March 19, 2021
                                        </div>
                                    </div>

                                    <div class="blog-post-content">
                                        <h3><router-link to="/blog-details/WhyRestudent">Why does your restaurant need an online website?</router-link></h3>

                                        <span>by <a href="#">WB-Software</a></span>

                                        <p>Each business has a different set of goals to reach, but the main among them is always reach. Digital marketing can really be helpful for many small and large scale businesses, here is why you need digital marketing. It is the most affordable means of...</p>
                                        <router-link to="/blog-details/WhyRestudent" class="read-more-btn">Read More <feather type="plus-circle"></feather></router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-12">
                        <aside class="widget-area" id="secondary">
                            <section class="widget widget_search">
                                <form class="search-form">
                                    <label>
                                        <span class="screen-reader-text">Search for:</span>
                                        <input type="search" class="search-field" placeholder="Search...">
                                    </label>
                                    <button type="submit"><feather type="search"></feather></button>
                                </form>
                            </section>

                            <section class="widget widget_startp_posts_thumb">
                                <h3 class="widget-title">Popular Posts</h3>

                                <article class="item">
                                    <router-link to="/blog-details/WhyECommerce" class="thumb">
                                        <span class="fullimage cover bg1" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 10, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyECommerce">How can eCommerce help your business?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedWebSide" class="thumb">
                                        <span class="fullimage cover bg2" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 21, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedWebSide">Why does your business need a website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedDigitalMarketing" class="thumb">
                                        <span class="fullimage cover bg3" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedDigitalMarketing">Why does your business need digital marketing?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/WhyRestudent" class="thumb">
                                        <span class="fullimage cover bg4" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyRestudent">Why does your restaurant need an online website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/AppVsWeb" class="thumb">
                                        <span class="fullimage cover bg5" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/AppVsWeb">App vs Website: which one is better?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/NeedApps" class="thumb">
                                        <span class="fullimage cover bg6" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedApps">Why does your business need an app?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                            </section>
                        </aside>
                    </div>
                </div>
			</div>
		</section>
		<!-- End Blog Area -->
    </div>
</template>

<script>
export default {
    name: 'BlogRightSidebarTwo'
}
</script>